module.exports = "/_next/static/images/c23748d344ca32537cc5a088071382f5-minus.svg.webp";